export const PRODUCTS_DISPLAYED_PER_PAGE = 24
export const EMBED_PRODUCTS_DISPLAYED_PER_PAGE = 12
export const PRODUCT_LIST_SEO_CONTENT_ID = 'seo-content'
